import { render, staticRenderFns } from "./ContactTabs.vue?vue&type=template&id=67eec0b6&scoped=true"
import script from "./ContactTabs.vue?vue&type=script&lang=js"
export * from "./ContactTabs.vue?vue&type=script&lang=js"
import style0 from "./ContactTabs.vue?vue&type=style&index=0&id=67eec0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eec0b6",
  null
  
)

export default component.exports